import { sortBy } from "lodash";
import { toCategoryName } from "@/utils";

export const filterLevels = <T extends { tag_level: number }>(
  scores: T[],
  levels: number[],
): T[] => {
  return scores.filter((x) => levels.includes(x.tag_level));
};

export const filterCategories = <
  T extends { tag_name: string; tag_category: string },
>(
  scores: T[],
  tag_name: string,
  tag_category: string,
  sort: string,
) => {
  // Create a copy
  let filteredScores = scores;

  // Filter by tag category
  filteredScores = filteredScores.filter(
    (x) => x.tag_category === toCategoryName(tag_category),
  );

  // Filter by tag name
  filteredScores = filteredScores.filter((x) => x.tag_name !== tag_name);

  // Order the scores
  filteredScores = sortBy(filteredScores, sort).reverse();

  return filteredScores;
};

export const filterBrands = <
  T extends {
    tag_group: string;
    tag_category: string;
    tag_name: string;
    tag_level: number;
  },
>(
  scores: T[],
  tag_group?: string,
  tag_category?: string,
  levels?: number[],
  searchText?: string,
  sort?: string,
  num?: number,
) => {
  // Create a copy
  let filteredScores = scores;

  // Filter by tag group
  if (tag_group) {
    filteredScores = filteredScores.filter(
      (x) => x.tag_group === toCategoryName(tag_group),
    );
  }

  // Filter by tag category
  if (tag_category) {
    filteredScores = filteredScores.filter(
      (x) => x.tag_category === toCategoryName(tag_category),
    );
  }

  // Filter by levels
  if (levels) {
    filteredScores = filterLevels(filteredScores, levels);
  }

  // Filter by name
  if (searchText) {
    filteredScores = filteredScores.filter((x) =>
      x.tag_name.toLowerCase().includes(searchText.toLowerCase()),
    );
  }

  // Order the scores
  if (sort) {
    filteredScores = sortBy(filteredScores, sort).reverse();
  }

  // Limit the number of results
  if (num) {
    filteredScores = filteredScores.slice(0, num);
  }

  return filteredScores;
};

export const filterItems = <
  T extends { tag_name: string; tag_category: string },
>(
  scores: T[],
  sort: string,
) => {
  // Create a copy
  let filteredScores = scores;

  // Order the scores
  filteredScores = sortBy(filteredScores, sort).reverse();

  return filteredScores;
};


export const filterScores = <
  T extends { tag_name: string; tag_group: string },
>(
  scores: T[],
  tag_group: string,
  sort: string,
) => {
  // Create a copy
  let filteredScores = scores;

  // Filter by tag group
  filteredScores = filteredScores.filter(
    (x) => x.tag_group === tag_group,
  );

  // Order the scores
  filteredScores = sortBy(filteredScores, sort).reverse();

  return filteredScores;
};
